export default __webpack_public_path__ + "static/media/basic-push-pin-10.3c7e3c46.png";